var _style, _path, _path2, _path3, _path4, _path5, _text, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBodyWaterPercentage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#fff !important;}\n\t.st1{fill:#fff !important;}\n\t.st2{font-family:'Poppins-SemiBold';}\n\t.st3{font-size:5.8839px;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.7,9.6c0,0,2.6,0.1,3.1-2.9c-0.1-2,0.6-4.2-2.5-5.4c-0.6-0.1-4-0.3-3.6,4.7C12,7,11.7,9.1,14.7,9.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.2,16.2v19.4c0,0-0.2,2,1.7,2.4c0.5-0.1,2.4,0.3,2.5-2.2c-0.1-2.5,0-9.2,0-9.2s0.1-1.9,1.6-1.6 c0.5,0.1,1.2,0.3,1.2,1.8c0.1,1.5,0,8.9,0,8.9s0,1.9,1.6,2.2c0.8,0.1,2.2,0.1,2.6-1.9c0-2.2,0-19.4,0-19.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.5,23.5c0,0,1.3,1.7,2.7,0.6c0.5-0.3,0.9-0.4,0.9-4.4s0-4.9,0-4.9s0.8-4.9-4.9-5.2c-4.5,0-9.1,0-9.1,0 S5.4,9.5,5.6,15c0,4.6,0,7.5,0,7.5S5.5,24,7,24.4c0.9-0.1,1.7,0,2.2-1.1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.8,17c0,0,0.2-2,1.9-1.4c0.2,0.2,1.2,0.8,0.3,1.9c-0.1,0.1-0.5,0.9-1.5,0.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.7,22.3c0,0-2.2-0.2-1.9-1.8c0.1-0.5,0.4-1.6,1.9-1.4c0.4,0.4,1.1,0.2,1.2,2.2"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 24.1406 31.1582)",
    className: "st1 st2 st3"
  }, "90%")), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6,12.3c0,0,1.5,0.9,2.1,1.1c0.6,0.3,1.4,0.8,3.4,0c1.9-0.8,2.9-1.3,5.9-0.4c0.7,0.4,2,1.4,4.2,0.3 c0.8-0.4,2.2-1.1,2.2-1.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyWaterPercentage);
export default __webpack_public_path__ + "static/media/BodyWaterPercentage.bf118101dddec371c1ecd58c37495064.svg";
export { ForwardRef as ReactComponent };